import { createApp } from "vue";
import App from "./App.vue";
import store from "./store/store";
import router from "./router";
import 'element-plus/dist/index.css'
import './static/css/element/index.scss'
import ElementPlus from "element-plus";
import zhTw from "element-plus/dist/locale/zh-cn.mjs";
import validator from "@/utils/validation.utils";
import './static/font/font.css'
// import { createGtag } from 'vue-gtag';
// import { VueGtag } from "vue-gtag";
import sendGtagEvent from "./gtagEvent";
// import config from "./config.js";

const app = createApp(App);
app.config.globalProperties.$validator = validator;


app
  // .use(createGtag, {
  //   config: { id: config.ga_key },
  // }, router)
  // .use(VueGtag, {
  //   config: { id: config.ga_key },
  // }, router)
  .mixin({
    methods: {
      sendGtagEvent: sendGtagEvent,
    },
  })
  .use(router)
  .use(store)
  .use(validator)
  .use(ElementPlus, {
    locale: zhTw,
  })
  .mount("#app");
